import React, { Component } from "react";
import LoaderButton from "../components/LoaderButton";
import Form from "react-bootstrap/Form";
// import FormControl from 'react-bootstrap/FormControl';
// import FormCheck from 'react-bootstrap/FormCheck'
import { Auth } from "aws-amplify";
import "./Login.css";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: ""
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  // Use async promise to wait for response from aws-amplify api
  handleSubmit = async event => {
    event.preventDefault();

    // change state to provide feedback to user during load
    this.setState({
      isLoading: true
    });

    // Amplify Authentication logic
    try {
      // Make call to Auth API using aws-amplify
      await Auth.signIn(this.state.email.toLowerCase(), this.state.password);
      this.props.userHasAuthenticated(true);
    // use history.push from react-router4 to redirect
    // user during login flow
    // Remove this because of auth and unauth routes in place
    // this.props.history.push("/");
    } catch ( err ) {
      alert(err.message);
    }
  }

  // TODO: Implement forgot password feature
  render() {
    return (
      <div className="Login">
        <Form onSubmit={ this.handleSubmit }>
          <p>
            <strong>Returning Users Please Login.</strong>
          </p>
          <Form.Group controlId="email">
            <Form.Label>
              Email address
            </Form.Label>
            <Form.Control autoFocus
              size="lg"
              type="email"
              placeholder="Enter email"
              value={ this.state.email }
              onChange={ this.handleChange } />
            <Form.Text className="text-muted">
              We will never share your email with anyone else.
            </Form.Text>
          </Form.Group>
          <Form.Group controlId="password">
            <Form.Label>
              Password
            </Form.Label>
            <Form.Control size="lg"
              type="password"
              placeholder="Password"
              value={ this.state.password }
              onChange={ this.handleChange } />
          </Form.Group>
          { /* FIXME: Get Remember me check working so that it grabs user email from cookie */ }
          <Form.Group controlId="rememberUser">
            <Form.Check type="checkbox" label="Remember Me" />
          </Form.Group>
          { /* LoaderButton Component */ }
          <LoaderButton block
            size="lg"
            disabled={ !this.validateForm() }
            variant="primary"
            type="submit"
            isLoading={ this.state.isLoading }
            text="Login"
            loadingText="Logging In..." />
        </Form>
      </div>
      );
  }
}
